import React from "react";
import {
    Box,
    Paper,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";

export default function ApplicationProgress({ currentStep }) {

    const steps = [
        "Personal Details",
        "Eligibility",
        "Documents",
        "Review"
    ];

    const theme = useTheme();
    const isXs = useMediaQuery("(max-width:400px)");
    const isSm = useMediaQuery(theme.breakpoints.down("sm"));
    const isMd = useMediaQuery(theme.breakpoints.down("md"));

    let visibleCount;

    if (isXs) {
        visibleCount = 2;
    } else if (isSm) {
        visibleCount = 3;
    } else {
        visibleCount = steps.length;
    }

    // Keep one upcoming step visible where possible
    const startIndex = Math.min(
        Math.max(currentStep - 1, 0),
        Math.max(steps.length - visibleCount, 0)
    );

    const visibleSteps = steps.slice(
        startIndex,
        startIndex + visibleCount
    );

    return (

        <Paper
            elevation={2}
            sx={{
                maxWidth: 1200,
                mx: "auto",
                mt: 4,
                mb: 4,
                px: {
                    xs: 2,
                    md: 4
                },
                py: 3,
                borderRadius: 2
            }}
        >

            <Typography
                variant="h6"
                sx={{
                    textAlign: "center",
                    fontWeight: 600,
                    mb: 3
                }}
            >
                Step {currentStep} of {steps.length}
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start"
                }}
            >

                {visibleSteps.map((step, index) => {

                    const actualIndex = startIndex + index;

                    return (

                        <React.Fragment key={step}>

                            <Box
                                sx={{
                                    width: 110,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center"
                                }}
                            >

                                <Box
                                    sx={{
                                        width: {
                                            xs: 34,
                                            sm: 42
                                        },
                                        height: {
                                            xs: 34,
                                            sm: 42
                                        },
                                        borderRadius: "50%",
                                        backgroundColor:
                                            actualIndex + 1 <= currentStep
                                                ? "#278BCB"
                                                : "#D9D9D9",
                                        color: "#FFF",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontWeight: 700,
                                        fontSize: {
                                            xs: "0.9rem",
                                            sm: "1rem"
                                        }
                                    }}
                                >
                                    {actualIndex + 1}
                                </Box>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        mt: 1.5,
                                        width: "100%",
                                        textAlign: "center",
                                        fontWeight:
                                            actualIndex + 1 === currentStep
                                                ? 700
                                                : 500,
                                        color:
                                            actualIndex + 1 <= currentStep
                                                ? "#278BCB"
                                                : "text.secondary",
                                        fontSize: {
                                            xs: "0.75rem",
                                            sm: "0.875rem"
                                        },
                                    }}
                                >
                                    {step}
                                </Typography>

                            </Box>

                            {index < visibleSteps.length - 1 && (

                                <Box
                                    sx={{
                                        width: 40,
                                        height: 4,
                                        mt: {
                                            xs: "15px",
                                            sm: "19px"
                                        },
                                        mx: 1,
                                        backgroundColor:
                                            actualIndex + 1 < currentStep
                                                ? "#278BCB"
                                                : "#D9D9D9"
                                    }}
                                />

                            )}

                        </React.Fragment>

                    );

                })}

                {/* Show trailing hyphen if more steps exist */}
                {startIndex + visibleCount < steps.length && (

                    <Box
                        sx={{
                            width: 40,
                            height: 4,
                            mt: {
                                xs: "15px",
                                sm: "19px"
                            },
                            ml: 1,
                            backgroundColor: "#D9D9D9"
                        }}
                    />

                )}

            </Box>

        </Paper>

    );

}